module.exports = __webpack_public_path__ + "img/import-yaml.187fbcc7.svg";